import { render, staticRenderFns } from "./FakeInput.vue?vue&type=template&id=e0f487b6&lang=pug&"
import script from "./FakeInput.vue?vue&type=script&lang=js&"
export * from "./FakeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports